import React, { Component } from 'react';
import ShowImg from './ShowImg';
import DrawCircle from './DrawCircle';
import MatchGame from './MatchGame';
import WriteLetter from './WriteLetter';
import ASRandJudge from './ASRandJudge';
import FlipFlopGameInteraction from './FlipFlopGameInteraction';

import AutoASRandJudge from '../review/AutoASRandJudge';
import AutoCircle from '../review/AutoCircle';
import AutoMatch from '../review/AutoMatch';
import AutoFlipFlop from '../review/AutoFlipFlop';
import AutoWriteLetter from '../review/AutoWriteLetter';
import ChooseWords from './ChooseWords';
import utils from '../../lib/utils';

class Course extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showPageNodes: props.showPageNodes || [],  //存放当前需要渲染的节点列表
            currStarCount: 0,   //当前的星星数
            currSubjectCount: 0,    //当前题目数（有starSubject=1的时候就加1）
            curRunChildNodeParent: props.curRunChildNodeParent || null,
            isPause: props.isPause || false,
            zIndex: 0,
            doneTryData: null,
            courseVideoEnd: false
        };

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            showPageNodes: nextProps.showPageNodes,
            currStarCount: nextProps.currStarCount,   //当前的星星数
            currSubjectCount: nextProps.currSubjectCount,    //当前题目数（有starSubject=1的时候就加1）
            curRunChildNodeParent: nextProps.curRunChildNodeParent,
            isPause: nextProps.isPause,
            doneTryData: nextProps.doneTryData
        });
    }

    componentDidMount() {
        const { zIndex } = this.state;
        this.setState({
            zIndex: zIndex + 1
        });
    }

    handleVideoPlay() {
        const that = this;
        const courseVideo = document.getElementById('courseVideo');
        let playPromise = courseVideo.play();
        if (playPromise !== undefined) {
            playPromise
                .then(_ => {

                })
                .catch(error => {
                    utils.showTips("播放失败，点击这里继续", -1, () => {
                        that.handleVideoPlay();
                    });
                });
        }
    }

    handleVideoEnd() {
        const { videoEnd } = this.props;
        if (videoEnd && typeof videoEnd === 'function') {
            videoEnd();
            this.setState({
                courseVideoEnd: true
            });
        }
    }

    handleChildCallback(returnScore, replaceData) {
        const { childCallback } = this.props;
        if (childCallback && typeof childCallback === 'function') {
            childCallback(returnScore, replaceData);
        }
    }

    handleImgError(id) {
        let _id = document.getElementById(id);
        _id && (_id.style.display = "none");
    }

    render() {
        const that = this;
        const { isReview } = this.props;
        const { showPageNodes, curRunChildNodeParent, currStarCount, currSubjectCount, zIndex, isPause, doneTryData, courseVideoEnd } = this.state;

        return (
            <div>
                {
                    showPageNodes && showPageNodes.length ?
                        showPageNodes.map((showPageNode, index) => {
                            if (showPageNode.actionType === "CircleGameInteraction_") {   //圈图动画，去掉之前画的圈
                                let drawCircle = document.getElementsByClassName('draw-circle');
                                if (drawCircle && drawCircle.length > 1) {
                                    for (let i = 0; i < drawCircle.length - 1; i++) {
                                        if (drawCircle[i] && drawCircle[i].parentNode) {
                                            drawCircle[i].parentNode.removeChild(drawCircle[i]);
                                        }
                                    }
                                }
                            }
                            let course_video = "";
                            if (showPageNode.actionType === "PlayVideo_" && showPageNode.objectID !== 'Teacher_' && !isReview) {
                                course_video = showPageNode.detail.url;
                                if (window.isDev) {
                                    course_video = course_video.replace("putaoabc-inc.com", "course.putaoabc.net.cn").replace("inner.putaoabc.net.cn:5002", "course.putaoabc.net.cn");
                                }
                            }
                            return (
                                <div key={index}>
                                    {
                                        (showPageNode.actionType === "ShowPic_" || showPageNode.actionType === "DisappearPic_") && !(showPageNode.detail.isEmpty && showPageNode.detail.isEmpty === 1) ?
                                            <ShowImg key={showPageNode.actionID} item={showPageNode} zIndex={zIndex} />
                                            :
                                            showPageNode.actionType === "ASRandJudge_" ?
                                                <ASRandJudge item={showPageNode} currStarCount={currStarCount} currSubjectCount={currSubjectCount} parentNode={curRunChildNodeParent} isReview={isReview}
                                                    childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)}
                                                />
                                                :
                                                showPageNode.actionType === "PlayVideo_" && showPageNode.objectID !== 'Teacher_' && !courseVideoEnd && !isReview ?
                                                    <div>
                                                        <video id="courseVideo" src={course_video} style={{
                                                            "position": "absolute",
                                                            "top": showPageNode.detail.pos.y * 100 + "%",
                                                            "left": showPageNode.detail.pos.x * 100 + "%",
                                                            "width": showPageNode.detail.size.width / 2 * window.mainSize.percent + "px",
                                                            "height": showPageNode.detail.size.height / 2 * window.mainSize.percent + "px",
                                                        }} /*controls*/ autoPlay playsInline
                                                            onCanPlay={() => that.handleVideoPlay()}
                                                            onEnded={() => that.handleVideoEnd()} />
                                                        <div style={{
                                                            "position": "absolute",
                                                            "top": showPageNode.detail.pos.y * 100 + "%",
                                                            "left": showPageNode.detail.pos.x * 100 + "%",
                                                            "width": showPageNode.detail.size.width / 2 * window.mainSize.percent + "px",
                                                            "height": showPageNode.detail.size.height / 2 * window.mainSize.percent + "px",
                                                        }} />
                                                    </div>
                                                    :
                                                    showPageNode.actionType === "CircleGameInteraction_" || showPageNode.actionType === "CircleReplayAction_" ?
                                                        <DrawCircle item={showPageNode} currStarCount={currStarCount} currSubjectCount={currSubjectCount} childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)} isReview={isReview} />
                                                        :
                                                        showPageNode.actionType === "MutiMatchGameInteraction_" || showPageNode.actionType === "AudioMutiMatchGameInteraction_" || (showPageNode.actionType === "MutiMatchGameWithDoneInteraction_" && (!curRunChildNodeParent || showPageNode.retryTimes)) ?
                                                            <MatchGame item={showPageNode} currStarCount={currStarCount} currSubjectCount={currSubjectCount} doneTryData={doneTryData} childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)} />
                                                            :
                                                            showPageNode.actionType === "FacsimileGameInteraction_" || showPageNode.actionType === "LetterReplayAction_" ?
                                                                <WriteLetter item={showPageNode} currStarCount={currStarCount} currSubjectCount={currSubjectCount} childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)} isReview={isReview} />
                                                                :
                                                                showPageNode.actionType === "FlipFlopGameInteraction_" || showPageNode.actionType === "PurbleReplayAction_" ?
                                                                    <FlipFlopGameInteraction item={showPageNode} currStarCount={currStarCount} currSubjectCount={currSubjectCount} childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)} isReview={isReview} />
                                                                    :
                                                                    showPageNode.actionType === "ShowTextArea_" || showPageNode.actionType === "ChooseWrongWordsInteraction_" || showPageNode.actionType === "ChooseRightWordsInteraction_" ?
                                                                        <ChooseWords item={showPageNode} currStarCount={currStarCount} currSubjectCount={currSubjectCount} childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)} />
                                                                        : showPageNode.actionType === "GiveStar_" || showPageNode.actionType === "GiveStar2_" ?
                                                                            <div id="giveStar" />



                                                                            :
                                                                            showPageNode.actionType === "ASRAndJudgeReplayAction_" ?
                                                                                <AutoASRandJudge item={showPageNode} />
                                                                                :
                                                                                showPageNode.actionType === "CIRCLE_REPLAY_DRAWLINE" ?
                                                                                    <AutoCircle item={showPageNode} />
                                                                                    :
                                                                                    !isPause && (showPageNode.actionType === "MATCH_REPLAY_MOVE" || showPageNode.actionType === "MATCH_DONE_REPLAY_MOVE" || showPageNode.actionType === "AUDIOMATCH_REPLAY_TAP" || showPageNode.actionType === "MatchReplayAction_" || showPageNode.actionType === "AudioMutiMatchReplayAction_" || showPageNode.actionType === "MatchWithDoneReplayAction_") ?
                                                                                        <AutoMatch item={showPageNode} />
                                                                                        :
                                                                                        !isPause && showPageNode.actionType === "PURBLE_REPLAY_TAP" ?
                                                                                            <AutoFlipFlop item={showPageNode} />
                                                                                            :
                                                                                            showPageNode.actionType === "LETTER_REPLAY_DRAWLINE" || showPageNode.actionType === "LETTER_REPLAY_FEEDBACK" ?
                                                                                                <AutoWriteLetter item={showPageNode} />
                                                                                                : null
                                    }
                                </div>
                            )
                        })
                        : null
                }

                <img id="myImg" alt="" src="" style={{ "position": "fixed", "bottom": 0 }} />
                <canvas style={{ "display": "none" }}></canvas>
            </div>
        )

    }
}

export default Course;



// WEBPACK FOOTER //
// ./src/components/on/Course.js